import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/Index.vue'
import Province from '../views/Province.vue'
import Detail from '../views/Detail.vue'
import Login from '../views/Login.vue'
import GroupManage from '../views/GroupManage.vue'
// ✅ 新增新增足迹页面
import AddRecord from '../views/AddRecord.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', name: 'Index', component: Index },
  { path: '/province', name: 'Province', component: Province },
  { path: '/detail', name: 'Detail', component: Detail },
  { path: '/login', name: 'Login', component: Login },
  { path: '/groupManage', name: 'GroupManage', component: GroupManage },
 
  {path: '/personal-footprint',name: 'PersonalFootprint',component: () => import('@/views/personal-footprint.vue')},
{path: '/footprint-stat',name: 'FootprintStat',component: () => import('@/views/footprint-stat.vue')
},

{path: '/poster-create',name: 'PosterCreate',component: () => import('@/views/poster-create.vue')
},
{
  path: '/help',
  name: 'HelpDescription',
  component: () => import('@/views/HelpDescription.vue')
},
{
  path: '/memories',
  name: 'Memories',
  component: () => import('@/views/Memories.vue')
},
{
  path: '/myCreatedGroup',
  name: 'MyCreatedGroup',
  alias: '/GroupCreatedList',
  component: () => import('@/views/GroupCreatedList.vue')
},
{
  path: '/myJoinGroup',
  name: 'MyJoinGroup',
  alias: '/GroupJoinedList',
  component: () => import('@/views/GroupJoinedList.vue')
},

{
  path: '/anniversary',
  name: 'Anniversary',
  component: () => import('@/views/Anniversary.vue')
},

{ path: '/annual-report', name: 'AnnualReport', component: () => import('@/views/AnnualReport.vue') },
  // ✅ 新增 AddRecord 路由
  { path: '/addRecord', name: 'AddRecord', component: AddRecord },
{
  path: '/personal-center',
  name: 'PersonalCenter',
  component: () => import('@/views/personal-center.vue')
},
  {
    path: '/sys-gateway-x9',
    name: 'AdminLogin',
    component: () => import('@/views/admin/AdminLogin.vue')
  },
  {
    path: '/sys-console-x9',
    component: () => import('@/views/admin/AdminLayout.vue'),
    children: [
      { path: 'user', name: 'AdminUser', component: () => import('@/views/admin/UserList.vue') },
      { path: 'content', name: 'AdminContent', component: () => import('@/views/admin/ContentList.vue') },
      { path: 'log', name: 'AdminLog', component: () => import('@/views/admin/LogList.vue') },
      { path: 'feedback', name: 'AdminFeedback', component: () => import('@/views/admin/FeedbackList.vue') },
      { path: 'admin-manage', name: 'AdminManage', component: () => import('@/views/admin/AdminManage.vue') }
    ]
  }

]
 
const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

// 检查 token 是否有效（至少没过期）
function isTokenValid(token) {
  if (!token) return false
  try {
    const payload = JSON.parse(atob(token.split('.')[1]))
    // exp 是秒级时间戳
    return payload.exp * 1000 > Date.now()
  } catch (e) {
    return false
  }
}

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  const adminToken = localStorage.getItem('admin_token')

  // ===== 后台登录页：永远放行 =====
  if (to.path === '/sys-gateway-x9') {
    next()
    return
  }

  // ===== 后台其他页面：需 admin_token =====
  if (to.path.startsWith('/sys-console-x9')) {
    if (!isTokenValid(adminToken)) {
      localStorage.removeItem('admin_token')
      next('/sys-gateway-x9')
    } else {
      next()
    }
    return
  }

  // ===== 主站路由：原有逻辑 =====
  const whiteList = ['/', '/login', '/help']
  const validMainToken = isTokenValid(token)
  if (!validMainToken) {
    // token 无效时清理掉本地缓存，让用户重新登录
    if (token) {
      localStorage.removeItem('token')
      localStorage.removeItem('currentUser')
    }
    if (whiteList.includes(to.path)) {
      next()
    } else {
      next('/login')
    }
  } else {
    if (to.path === '/login') {
      next('/')
    } else {
      next()
    }
  }
})
export default router